<template>
    <div class="edit-note-widget">
        <div class="note-header">
            <div class="note-title">
                <input type="text" v-model="form.title" placeholder="Add Title Here...">
            </div>
        </div>

        <div class="note-details">
            <div class="note-top-inputs">

                <div class="detail-item" v-if="account">
                    <span class="label">
                        <img src="@/assets/icons/notes/user.svg">
                        Contacts</span>

                    <searchSelectInput :url="`/contact/search/${account.id}`" :miltiple="true" :hasPagination="true"
                        v-model="contacts" placeholder="Search Contact">

                        <template v-slot:result="{ result }">
                            <span class="search-contact-item">{{ result.first_name | validate }}
                                {{ result.last_name | validate }}</span>
                        </template>

                        <template v-slot:selected="{ selected }">
                            <span class="selected-search-contact-item">{{
                                selected.first_name | validate
                            }}</span>
                        </template>
                    </searchSelectInput>
                </div>
                <div class="detail-item">
                    <span class="label">
                        <img src="@/assets/icons/notes/user.svg">
                        Responsible / Assigned</span>
                    <searchSelectInput url="/company/search/manager" :miltiple="true" type="site" v-model="assigned"
                        placeholder="Search for a person">
                        <template v-slot:result="{ result }">
                            <span class="search-contact-item"><img width="20" v-if="result.profile_picture"
                                    :src="$fullUrl('images/profiles/' + result.profile_picture)" />
                                <img v-else width="20" src="@/assets/avatar.png" />
                                {{ result.first_name | validate }}
                                {{ result.last_name | validate }}</span>
                        </template>

                        <template v-slot:selected="{ selected }">
                            <span class="selected-search-contact-item">
                                <img width="20" v-if="selected.profile_picture"
                                    :src="$fullUrl('images/profiles/' + selected.profile_picture)" />
                                <img v-else width="20" src="@/assets/avatar.png" />
                                {{ selected.first_name | validate }}</span>
                        </template>
                    </searchSelectInput>
                </div>



            </div>
            <div class="note-editor">
                <span class="label">
                    <img src="@/assets/icons/notes/description.svg">
                    Description</span>
                <html-editor placeholder="Enter your notes" v-model="form.noteContent" class="notes-editor-widget"
                    id="edit-descr" />
            </div>

            <div class="note-attachments">
                <h3> <img src="@/assets/icons/notes/attachment.svg"> Attachment ({{ form.attachments.length }})</h3>
                <div class="attachment-list">
                    <div class="attachment-item" v-for="(file, index) in form.attachments" :key="index">
                        <div class="file-info">
                            <div class="file-type" :class="getFileTypeClass(file.type)">{{ getFileExtension(file.name)
                                }}</div>
                            <div class="file-details">
                                <span class="file-name">{{ file.name }}</span>
                                <span class="file-meta">{{ file.file ? formatFileSize(file.size) : "Uploaded" }}</span>
                            </div>
                        </div>
                        <div class="file-actions">
                            <button class="delete-btn" @click="removeFile(file, index)">
                                <img src="@/assets/icons/notes/trash.svg" alt="delete" />
                            </button>
                        </div>
                    </div>
                    <div class="upload-container">
                        <input type="file" ref="fileInput" @change="handleFileUpload"
                            accept=".pdf,.doc,.docx,.txt,.xls,.xlsx" style="display: none" multiple>
                        <button class="upload-btn" @click="triggerFileInput">
                            Upload Document
                            <img src="@/assets/icons/notes/upload.svg">
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="note-footer">
            <widgetButton @click="addNewNote()" :loading="submit_note_loading" style="width: 120px" class="btn-primary">
                Save
            </widgetButton>
            <widgetButton @click="closeModal()" :loading="false" style="width: 120px"
                class="btn-transparent-secondary ">
                Cancel
            </widgetButton>
        </div>
    </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
    name: 'EditNoteWidget',
    props: {
        note_item: {
            type: Object,
            default: null
        },
        account: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            assigned: {
                added: [],
                removed: [],
            },
            tags: {
                added: [],
                removed: [],
            },
            contacts: {
                added: [],
                removed: [],
            },
            form: {
                people: [],
                status: '',
                tags: [],
                note_type: '',
                noteContent: '',
                noteAsText: '',
                attachments: [],
                title: '',
                account_id: null,
                contacts: []
            },
            submit_note_loading: false
        }
    },
    mounted() {
        let vm = this;
        if (vm.note_item) {
            vm.setFormData();
        } else {
            vm.resetForm();
        }
    },
    methods: {
        removeFile(file, index) {
            let vm = this;
            if (file.file) {
                vm.form.attachments.splice(index, 1);
            } else {
                vm.$store.dispatch("NOTES_DELETE_ATTACHMENT", {
                    note_id: vm.note_item.id,
                    attachment_name: file.name
                }).then(() => {
                    vm.form.attachments.splice(index, 1);
                    vm.$notify({
                        title: 'Success',
                        message: 'Attachment deleted successfully',
                        type: 'success'
                    });
                }).catch((error) => {
                    vm.$notify({
                        title: 'Error',
                        message: 'Failed to delete attachment',
                        type: 'error'
                    });
                });
            }
        },
        setFormData() {
            let vm = this;
            vm.form.id = vm.note_item.id;
            vm.assigned = {
                added: [],
                removed: [],
            };
            vm.tags = {
                added: [],
                removed: [],
            };
            vm.contacts = {
                added: [],
                removed: [],
            };
            vm.form.people = [];
            vm.form.tags = [];
            if (vm.note_item.people) {
                vm.note_item.people.forEach((item) => {
                    eventBus.$set(item, "on_update", true);
                    vm.assigned.added.push(item);
                });
            }
            if (vm.note_item.tags) {
                vm.note_item.tags.forEach((item) => {
                    eventBus.$set(item, "on_update", true);
                    vm.tags.added.push(item);
                });
            }
            vm.note_item.contacts.forEach((item) => {
                eventBus.$set(item, "on_update", true);
                vm.contacts.added.push(item);
            });
            vm.form.account_id = vm.account.id;
            vm.form.status = vm.note_item.status || '';
            vm.form.note_type = vm.note_item.type || '';
            vm.form.noteContent = vm.note_item.content || '';
            vm.form.noteAsText = vm.note_item.content ? vm.note_item.content.replace(/<[^>]*>/g, '') : '';
            vm.form.attachments = vm.note_item.attachments.map((item) => {
                return {
                    file: null,
                    name: item,
                    size: 0,
                    type: vm.getFileExtension(item),
                    date: new Date().toLocaleDateString()
                }
            }) || [];
            vm.form.title = vm.note_item.title || '';
        },
        resetForm() {
            let vm = this;
            vm.assigned = {
                added: [],
                removed: [],
            };
            vm.contacts = {
                added: [],
                removed: [],
            };
            vm.tags = {
                added: [],
                removed: [],
            };
            vm.form = {
                people: [],
                status: '',
                tags: [],
                note_type: '',
                noteContent: '',
                noteAsText: '',
                attachments: [],
                title: '',
                account_id: vm.account ? vm.account.id : null,
                contacts: []
            };
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileUpload(event) {
            const files = event.target.files;
            const allowedTypes = [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'text/plain',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            let vm = this;
            for (let file of files) {
                if (allowedTypes.includes(file.type)) {
                    this.form.attachments.push({
                        file: file,
                        name: file.name,
                        size: file.size,
                        type: file.type,
                        date: new Date().toLocaleDateString()
                    });
                } else {
                    this.$toast.error('Only document files are allowed');
                }
            }
        },
        getFileExtension(filename) {
            return filename.split('.').pop().toUpperCase();
        },
        formatFileSize(size) {
            if (size < 1024) return size + ' B';
            else if (size < 1048576) return (size / 1024).toFixed(1) + ' KB';
            else return (size / 1048576).toFixed(1) + ' MB';
        },
        getFileTypeClass(type) {
            const typeMap = {
                'application/pdf': 'pdf',
                'application/msword': 'doc',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
                'text/plain': 'txt',
                'application/vnd.ms-excel': 'xls',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xls'
            };
            return typeMap[type] || 'default';
        },
        validateForm() {
            const rules = {
                title: {
                    run: (value) => {
                        if (value && value.length > 0) {
                            return false;
                        }
                        return "Title cannot be empty";
                    },
                },
            };

            return this.$isFieldsValidated(this.form, rules);
        },
        async addNewNote() {
            let vm = this;
            if (!this.validateForm()) {
                return;
            }

            // Format people data
            if (this.assigned.added.length > 0) {
                this.form.people = this.assigned.added.map((item) => {
                    return {
                        id: item.id,
                        first_name: item.first_name,
                        last_name: item.last_name,
                        profile_picture: item.profile_picture,
                    };
                });
            }

            // Format tags data
            this.form.tags = this.tags.added.map((item) => {
                return item.name;
            });

            const formData = new FormData();

            if (this.note_item) {
                formData.append('id', this.note_item.id);
            }

            // Append basic form data
            formData.append('title', this.form.title);
            formData.append('status', this.form.status);
            formData.append('note_type', this.form.note_type);
            formData.append('noteContent', this.form.noteContent);

            // Append people as JSON string
            formData.append('people', JSON.stringify(this.form.people || []));

            // Append tags
            formData.append('tags', JSON.stringify(this.form.tags || []));

            // Append files
            this.form.attachments.forEach((attachment, index) => {
                if (attachment.file) {
                    formData.append(`attachments[${index}]`, attachment.file);
                }
            });
            formData.append('account_id', this.form.account_id);

            this.form.contacts = this.contacts.added.map((item) => {
                return item.id;
            });
            formData.append('contacts', JSON.stringify(this.form.contacts || []));

            if (!this.note_item) {
                vm.submit_note_loading = true;
                vm.$store
                    .dispatch("NOTES_ADD_NEW", formData)
                    .then((responce) => {
                        vm.submit_note_loading = false;
                        vm.$emit('added');
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Note is now added",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.submit_note_loading = false;
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Something went wrong, try again",
                            type: "warn",
                            duration: 3000,
                        });
                    });
            } else {
                // For contacts
                const contacts_added = vm.contacts.added
                    .filter((item) => !item.on_update)
                    .map((item) => {
                        return item.id;
                    });
                const contacts_removed = vm.contacts.removed.map((item) => {
                    return item.id;
                });

                formData.append('contacts_added', JSON.stringify(contacts_added || []));
                formData.append('contacts_removed', JSON.stringify(contacts_removed || []));

                // for people
                const people_added = vm.assigned.added
                    .filter((item) => !item.on_update)
                    .map((item) => {
                        return item.id;
                    });
                const people_removed = vm.assigned.removed.map((item) => {
                    return item.id;
                });

                formData.append('people_added', JSON.stringify(people_added || []));
                formData.append('people_removed', JSON.stringify(people_removed || []));

                vm.submit_note_loading = true;
                vm.$store
                    .dispatch("NOTES_UPDATE", formData)
                    .then((responce) => {
                        vm.submit_note_loading = false;
                        vm.$emit('updated');
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Note is now updated",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.submit_note_loading = false;
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Something went wrong, try again",
                            type: "warn",
                            duration: 3000,
                        });
                    });
            }

        },
        closeModal() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.edit-note-widget {
    padding-bottom: 100px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    overflow-y: auto;



    .note-header {
        display: flex;
        align-items: center;
        padding: 0px 20px;
        width: 100%;
        margin-top: 20px;

        .note-title {
            width: 100%;

            input {
                font-size: 16px;
                margin: 0;
                border: 1px solid #ddd;
                outline: none;
                padding: 10px;
                border-radius: 4px;
                width: 100%;
                height: 50px;
            }
        }


    }

    .note-details {
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding: 0px 20px;

        .note-top-inputs {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
            margin-bottom: 10px;

            .detail-item {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .label {
                    color: #666;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }

                .status-completed {
                    color: #4CAF50;
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 8px;
                        height: 8px;
                        background: #4CAF50;
                        border-radius: 50%;
                    }
                }

                .people-list {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    gap: 10px;

                    .person {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        padding: 4px;
                        background: rgba(8, 132, 175, 0.1);
                        border-radius: 20px;

                        img {
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                        }
                    }

                    .add-person {
                        border: 1px solid rgba(244, 244, 244, 1);
                        background: none;
                        color: #0884AF;
                        cursor: pointer;
                        padding: 4px 8px;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        gap: 5px;

                        &:hover {
                            background: rgba(8, 132, 175, 0.1);
                        }
                    }
                }
            }
        }

        .note-editor {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .label {
                color: #666;
                width: 80px;
                display: flex;
                align-items: center;
                gap: 5px;
            }


            .notes-editor-widget {
                flex-grow: 1;
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 10px;
            }
        }

        .note-attachments {

            h3 {
                display: flex;
                align-items: center;
                gap: 5px;
                margin-bottom: 15px;
                color: rgba(175, 175, 175, 1);
                font-size: 12px;
                font-weight: normal;
            }

            .attachment-list {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;

                .attachment-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 4px;

                    .file-info {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        .file-type {
                            padding: 4px 8px;
                            border-radius: 4px;
                            font-size: 12px;
                            font-weight: bold;

                            &.pdf {
                                background: #F44336;
                                color: white;
                            }

                            &.doc {
                                background: #2196F3;
                                color: white;
                            }

                            &.txt {
                                background: #4CAF50;
                                color: white;
                            }

                            &.xls {
                                background: #4CAF50;
                                color: white;
                            }

                            &.default {
                                background: #9E9E9E;
                                color: white;
                            }
                        }

                        .file-details {
                            display: flex;
                            flex-direction: column;
                            min-width: 0;
                            max-width: 200px;

                            .file-name {
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-size: 12px;
                                width: 120px;
                            }

                            .file-meta {
                                color: #666;
                                font-size: 10px;
                            }
                        }
                    }

                    .file-actions {
                        display: flex;
                        gap: 10px;

                        button {
                            background: none;
                            border: none;
                            cursor: pointer;
                            padding: 4px;
                            border-radius: 4px;

                            &:hover {
                                background: #f5f5f5;
                            }
                        }
                    }
                }

                .upload-btn {
                    display: flex;
                    align-items: center;
                    background: none;
                    border: 2px dashed #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                    color: #666;
                    justify-content: center;
                    height: 40px;

                    &:hover {
                        background: #f5f5f5;
                    }

                    img {
                        width: 14px;
                        margin-left: 8px;
                    }
                }
            }

        }
    }

    .note-footer {
        padding: 10px 20px;
        display: flex;
        gap: 10px;
    }
}

.upload-container {
    width: 100%;
    grid-column: span 2;
}
</style>
